import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider as HelmetProviderClass } from 'react-helmet-async';
const HelmetProvider = HelmetProviderClass as React.FC<{ children: React.ReactNode }>;
import './styles/globals.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
